import React, { Component } from 'react'
import AOS from 'aos';
import './css/building.css'

class Building extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <div className="building">
                <div className="building-image">
                    <div className="building-text">
                        <div className="odd" data-aos="fade-left" data-aos-delay="80" data-aos-duration="1600">
                            <h1>WE ARE BUILDING GENERATIONAL <br/> WEALTH</h1>
                            <p>Join us and be part of our community.</p>
                        </div>
                        <div className="bis" data-aos="fade-up" data-aos-delay="80" data-aos-duration="1400">
                            <h1>RECORDED CONTENTS</h1>
                            <p>100+</p>
                        </div>
                        <div className="bis" data-aos="fade-up" data-aos-delay="90" data-aos-duration="1500">
                            <h1>REGISTERED TRADERS</h1>
                            <p>100+</p>
                        </div>
                        <div className="bis" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1600">
                            <h1>Reaching Community</h1>
                            <p>10,000+</p>
                        </div>
                    </div>
                </div>
            </div>  
        )
    }
}

export default Building;